import type { Vendor } from 'admin/src/types';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface VendorsState {
  core: {
    vendors: Vendor[];
    loading: boolean;
    loaded: boolean;
    error: string | null;
  };
}

const initialVendorsState = {
  vendors: [],
  loading: false,
  loaded: false,
  error: null,
};

const initialState: VendorsState = {
  core: { ...initialVendorsState },
};

const vendorsSlice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {
    fetchVendors: (state) => {
      state.core.loading = true;
      state.core.loaded = false;
      state.core.error = null;
    },
    setVendors: (state, action: PayloadAction<Vendor[]>) => {
      state.core.vendors = action.payload;
      state.core.loading = false;
      state.core.loaded = true;
      state.core.error = null;
    },
    fetchVendorsFailure: (state, action: PayloadAction<string>) => {
      state.core.loading = false;
      state.core.loaded = true;
      state.core.error = action.payload;
    },
  },
});

export const { fetchVendors, setVendors, fetchVendorsFailure } = vendorsSlice.actions;

export default vendorsSlice.reducer;
